<template>
</template>

<script>
    import {auth} from '../services'

    auth.logout();
    document.location.href = '/';

    export default {
        data() {
            return {}
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Logout.vue?100c8c55